export class TipoAtivoConstants {
    static TIPO_BOLSA = "B"
    static TIPO_CRIPTOMOEDAS = "C"
    static TIPO_FUNDOS_IMOBILIARIOS = "FII"
    static TIPO_FUNDOS_INDICE = "ETF"
    static TIPO_INDICES = "INDICE"
    static TIPO_EUA = "EUA"
    static TIPO_BDR = "BDR"
}